import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CataloguePlanningService } from './catalogue-planning.service';

/**
 * Allows a route only for slotting tenants; catalogue tenants are sent to /promotions.
 * Used on the slotting boards and on the legacy promotion-details screens, which must not
 * write detail lines for a catalogue tenant.
 *
 * Uses the cached effective method: an unavailable method counts as slotting (fail open).
 * A 401/403 keeps the previous behaviour and redirects to /promotions.
 */
@Injectable({ providedIn: 'root' })
export class SlottingMethodGuard implements CanActivate {
  constructor(private readonly planning: CataloguePlanningService, private readonly router: Router) {}
  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const settings = await firstValueFrom(this.planning.getEffectiveMethod());
      return settings.method === 'catalogue' ? this.router.parseUrl('/promotions') : true;
    } catch { return this.router.parseUrl('/promotions'); }
  }
}

/** Allows the planning-method settings route only when the server says the user can manage it. */
@Injectable({ providedIn: 'root' })
export class PlanningMethodAdminGuard implements CanActivate {
  constructor(private readonly planning: CataloguePlanningService, private readonly router: Router) {}
  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const settings = await firstValueFrom(this.planning.getEffectiveMethod());
      return settings.canManage ? true : this.router.parseUrl('/promotions');
    } catch { return this.router.parseUrl('/promotions'); }
  }
}
